import { API_ERRO } from '@/constants/ConstantApiErro';
import router from '@/router';
import { useStoreAuth } from '@/stores/StoreAuth';
import { useStoreNotify } from '@/stores/StoreNotify';
import axios from 'axios';
import { isEmpty } from 'lodash';

let controller = new AbortController();

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_APP_API,
  headers: {
    Accepted: 'application/json',
  },
  signal: controller.signal,
});

function doesEndpointRequireToken(url) {
  const unprotectedEndpoints = ['app/version', 'auth/', 'api.ipify.org'];
  return !unprotectedEndpoints.some((endpoint) => url.includes(endpoint));
}

function hasTokenExpired() {
  const now = Math.floor(Date.now() / 1000);
  const storeAuth = useStoreAuth();

  return storeAuth.tokenExpirationDate < now;
}

function handleInvalidToken() {
  localStorage.removeItem('access_Token');
  localStorage.removeItem('refresh_Token');
  localStorage.removeItem('access_token_expiration_date');

  // Desativa alerta de sessão expirada devido a problema de tarefa CON-4468

  // const message = 'Sessão expirada. Faça login novamente para continuar.';
  // const storeNotify = useStoreNotify();
  // storeNotify.notifyError({ message, isUnique: true });

  router.push({ name: 'RouteLogin' });

  controller.abort(API_ERRO.TOKEN_EXPIRADO);
  resetAbortController();
}

function handleServerError() {
  controller.abort(API_ERRO.ERRO_SERVIDOR);
  resetAbortController();
}

function resetAbortController() {
  controller = new AbortController();
  axiosInstance.defaults.signal = controller.signal;
}

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_Token');

    config.headers.ipAddress = localStorage.getItem('ipAddress');

    if (doesEndpointRequireToken(config.url) && (isEmpty(token) || (!isEmpty(token) && hasTokenExpired()))) {
      handleInvalidToken();
    }

    if (token && !config.confirmingPassword) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },

  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) return new Promise(() => {});

    const failedRequestRoute = error.config?.url;

    switch (error.response?.status) {
      case 401:
        // Não deve mostrar mensagem de sessão expirada quando usuário errar as credenciais de acesso
        if (!failedRequestRoute.includes('auth/oauth2/token')) {
          handleInvalidToken();
        }
        break;

      case 500:
        handleServerError();
        break;

      default:
        break;
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
